import { HostBinding,Renderer2,HostListener,AfterViewChecked,ChangeDetectorRef,ElementRef,ViewChild,ViewChildren,QueryList,Component, OnInit, OnChanges, OnDestroy ,SimpleChanges, AfterViewInit,ViewEncapsulation} from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {NewsletterService} from '../../services/newsletter.service';
import {IRule} from '../../irule';
import{TemplateService} from '../../services/template.service';
import{ArticleService} from '../../services/article.service';
import {NotificationService} from '../../services/notification.service';

declare var $:any;


@Component({
  selector: 'app-notification-list',
  templateUrl: './notification.component.html',
 
})

export class NotificationListComponent extends BaseComponent implements OnInit,AfterViewInit,IRule {

  @HostBinding('style.width') public width: string = '100%';

  templateId:number=0;
  notificationId:number=0;
  unSelectAll:boolean=false;
 
  loader_image:boolean = true;

  record_empty:number =0;

  record_offset:number = 0;
  
  per_page:number = 10;

  notification:any=[];
  notifications:any=[];
  deletedId:any=[]

  orderList=[
    {key:'createdDate',value:'Created Date'},
    {key:'updatedDate',value:'Updated Date'}   
  ]

  isDescToggle:boolean=true;
  isSelectDesc = ' desc';
   msg:any;
   toastr:any;
   homeservice:any;
   _router:any;
   token:any;
   search:any='';
   selectedOrder:any=[];
   userName='';
   navigationsType=[];

  constructor(  private ns:NotificationService,private ref:ChangeDetectorRef,homeservice:HomeService,_router: Router,private newsService:NewsletterService , toastr: ToastrService,private renderer: Renderer2, msg:MessageService,private templateService:TemplateService , private articleService:ArticleService){

    super(msg,toastr,homeservice,_router);

    try{
        

      this.msg = msg;
      this.toastr = toastr;
      this.homeservice = homeservice;
      this._router =_router;

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
  
      if(!tokenA) throw 'Error in parse';
      
      if(!JSON.parse(tokenA)) throw 'Error in json parse';
    
      tokenA = JSON.parse(tokenA);

      this.token = tokenA.token;
 
 

  

    }catch(exec){

    }


  }

 


   searchList(offset:number){


    


    this.record_empty =1 ;

    this.loader_image =true;


    this.record_offset = offset;


    let data={};

 

   
    data['limit'] = this.per_page;

    data['offset'] =this.record_offset;

    data['page']='notification';

  
    let data2={
      token:this.token, 
      reqData: data
    } 

  



    this.ns.notificationData(data2).subscribe( (elem)=>{


     

      if(elem.status =='success'){

        this.userName=elem.user.name;

        this.navigationsType=elem.navigation;

        this.notification = elem.notification;
 
        this.broadcast_menu();    

        if( elem.notifications.length > 0) {

          

          this.record_empty =0 ;

          this.loader_image =false;          
 

          if(this.notifications.length ==0 ){


            this.userName=elem.user.name;

            this.navigationsType=elem.navigation;      

            this.notification = elem.notification;

            this.notifications = elem.notifications;

            if (!this.ref['destroyed']) {
              this.ref.detectChanges();
            }

       

          } else{



            if(this.record_offset == 0){

                this.notification = elem.notification;

                this.notifications = elem.notifications;

                this.userName=elem.user.name;

                this.navigationsType=elem.navigation;      
    
   
            } else {


              elem.notifications.forEach(element => {
             
                this.notifications.push(element);               
                               
              });
             
            }

      


            if (!this.ref['destroyed']) {
              this.ref.detectChanges();
            }

          }     




        } else{
      
 
          this.record_empty =1 ;

          this.loader_image =false;    
     

          if(this.record_offset !=0){

            this.record_offset-=this.per_page;

         
          } else{

            this.notifications = elem.notifications;

          }

    


        }

      
        this.notifications.map((x)=>{
           x.ischecked=false
        })



      } else{
        
       
        this.loader_image =false;

        this._router.navigate(['/login']);


      }

    });



   }

  ngOnInit() {


    window.scrollTo(0,0);

    this.searchList(0);

  }

  ngAfterViewInit(){

    
    $(document).ready(function() {

        window.scrollTo(0, 0);

        $('[data-toggle="popover"]').popover('hide');

        $('.tooltip-custom').tooltip("hide");

    });
    

    $(window).on("scroll", function() {

       
      //console.log('ee');

      if(this._router.url == '/notification'){





        if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
          



           if(this.record_empty == 0){

              this.record_offset+=this.per_page;

              this.searchList(this.record_offset);

            }
          

        }




      }

 



    }.bind(this));



  }

  broadcast_menu(){
 
    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});

 }

abc(event,id){

  if(event.target.checked){
    this.deletedId.push(id)
    this.notifications.map((x)=>{
      if(x.id==id){
        x.ischecked=true
      }
    })
  }else{

    let index = this.deletedId.indexOf(id);
    this.deletedId.splice(index,1)
    this.notifications.map((x)=>{
      if(x.id==id){
        x.ischecked=false
      }
    })
  }
 
}

deleteAll(){
  this.unSelectAll =true
  this.notifications.map((x)=>{
    this.deletedId.push(x.id)
    x.ischecked=true
  })
 
}

UnselectAll(){
  this.unSelectAll =false;
  this.deletedId = []
  this.notifications.map((x)=>{
    x.ischecked=false
  })
}


notification_remove(){

  this.notificationId =this.deletedId;

  if(this.deletedId.length>0){
    $('#success-popup').modal('show');
  }else{
    this.toastr.warning('Please select notification you want to delete!', '', {timeOut: 3000});
  }

  


}


deleteNotification(){

  // console.log('length',this.notifications.length)
  
  let data={
    token:this.token,
    reqData:{
      id:this.notificationId, 
      archive:true,
      'page':'notification'
    }
   
    //offset:this.record_offset
  }
  // console.log(data);
  this.loader_image =true;


   this.articleService.removeNotification(data).subscribe( (res)=>{
          


     if(res.status=='success'){
      
      // this.deletedId.map((x)=>{

      //  let catI = this.notifications.findIndex( (elm) => { return  elm.id == x});
      //  this.notifications.splice(catI,1);

      // })

      //  console.log(this.notifications);
      
      let data={};
  
      let data2={
        token:this.token, 
        reqData: data
      } 
  
      this.ns.notificationData(data2).subscribe( (elem)=>{
  
        if(elem.status =='success'){   
          this.loader_image =false;
          this.msg.sendMessage({'type':'count','length':elem.notification.count});
          this.notificationId =-1;
          this.deletedId = []
          this.unSelectAll = false
          if( elem.notifications.length > 0) {
            this.notifications = elem.notifications;
            this.notifications.map((x)=>{
              x.ischecked=false
           })
          }else{
            this.notifications = elem.notifications;
          }
        }
      })

     

     }else{
      this.notificationId =-1;
     }

     

   });

  


}

}
